module.exports = __webpack_public_path__ + "img/MatPL-1.caa8fa05.png";